module.exports = __webpack_public_path__ + "img/guide-safari@2x.462c33c6.jpg";